import React from 'react';
import { render } from '@testing-library/react';
import { Grid } from './Grid';

describe('Grid', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Grid data-auto-sel="automation-selector">
				<Grid.Row key={1}>
					<Grid.Column width={3}>Column 1</Grid.Column>
					<Grid.Column width={4}>Column 2</Grid.Column>
					<Grid.Column width={5}>Column 3</Grid.Column>
				</Grid.Row>
			</Grid>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Grid>
				<Grid.Row key={1} data-auto-sel="automation-selector">
					<Grid.Column width={3}>Column 1</Grid.Column>
					<Grid.Column width={4}>Column 2</Grid.Column>
					<Grid.Column width={5}>Column 3</Grid.Column>
				</Grid.Row>
			</Grid>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Grid>
				<Grid.Row key={1}>
					<Grid.Column width={3} data-auto-sel="automation-selector">
						Column 1
					</Grid.Column>
					<Grid.Column width={4}>Column 2</Grid.Column>
					<Grid.Column width={5}>Column 3</Grid.Column>
				</Grid.Row>
			</Grid>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
